import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=65d65b21&scoped=true"
import script from "./productDialog.vue?vue&type=script&lang=js"
export * from "./productDialog.vue?vue&type=script&lang=js"
import style0 from "./productDialog.vue?vue&type=style&index=0&id=65d65b21&prod&lang=scss&scoped=true"
import style1 from "./productDialog.vue?vue&type=style&index=1&id=65d65b21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d65b21",
  null
  
)

export default component.exports